import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const InteractionAccountsModelSchema = z
  .object({
    id: z.string(),
    interaction_id: z.string(),
    account_id: z.string()
  })
  .strict()

export const InteractionAccountsModelFields = makeFieldKeys(InteractionAccountsModelSchema)

export type InteractionAccountsModel = z.infer<typeof InteractionAccountsModelSchema>

function validateInteractionAccountsModel(data: unknown): InteractionAccountsModel {
  try {
    return validateWithZodSchema(InteractionAccountsModelSchema, data, 'interaction accounts model')
  } catch (error) {
    throw new Error(`Interaction accounts model validation failed: ${error}`)
  }
}
